/* PROA · PVPR NOS CARTÕES — pedido do Silva, 18/09/2026.
   "Você fez lá dentro do produto, mas aqui no cartão do lado de fora você não
   fez. Isso tem que aparecer em tudo." E depois, mais uma vez: "tem que
   aparecer em qualquer lado. Se eu vou dentro da marca, se eu vou onde parar,
   em qualquer lado."

   GENÉRICO por desenho: qualquer bloco de preço marcado com
   `data-proa-pvpr="<handle>"` recebe o tratamento, seja qual for a secção. Só
   se marcam os blocos que NÃO passam pelo `snippets/price.liquid` (esse já
   tem o PVPR embutido): as montras da página inicial, o "Continua de onde
   ficaste", o Mercado e o Guia de curvatura.

   Regras:
   - no máximo 4 pedidos ao mesmo tempo;
   - uma cache em memória por handle, para o mesmo produto nunca se pedir
     duas vezes (a mesma página pode repetir o mesmo produto em duas secções);
   - se um pedido falhar, o bloco fica como estava, sem erro na consola;
   - nunca toca num bloco que já tenha riscado (é uma promoção a sério, o
     PVPR não se mostra) nem num que já tenha sido processado. */
(function () {
  if (window.__proaPvprCartoes) return;
  window.__proaPvprCartoes = true;

  var MAX_PARALELOS = 4;
  var cache = {}; /* handle -> Promise<dados|null> */
  var emCurso = 0;
  var fila = [];

  /* Sem `Intl.NumberFormat` (que mete um espaço fino antes do "€", auditoria de 18/09):
     duas casas decimais, vírgula e o símbolo colado ao número, sempre. */
  function euro(n) {
    return Number(n).toFixed(2).replace('.', ',') + '€';
  }

  /* "9,90 €", "9,90€" ou "1.234,56 €" (formato pt-PT: ponto de milhares, vírgula decimal)
     → cêntimos. `null` se não conseguir ler nenhum número. */
  function paraCentimos(texto) {
    if (!texto) return null;
    var limpo = String(texto).replace(/[^0-9.,]/g, '').trim();
    if (!limpo) return null;
    limpo = limpo.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(limpo);
    if (isNaN(n)) return null;
    return Math.round(n * 100);
  }

  /* O preço que o cartão JÁ mostra, em cêntimos, lido do próprio DOM. */
  function precoMostrado(preco) {
    var alvo = preco.querySelector('b') || preco;
    return paraCentimos(alvo.textContent);
  }

  function temRiscado(preco) {
    return !!preco.querySelector('s');
  }

  function jaProcessado(preco) {
    return !!preco.querySelector('.proa-pvpr');
  }

  function candidato(preco) {
    if (!preco.getAttribute('data-proa-pvpr')) return false;
    if (temRiscado(preco)) return false;
    if (jaProcessado(preco)) return false;
    return true;
  }

  function pedaco(classe, texto) {
    var s = document.createElement('span');
    s.className = classe;
    s.textContent = texto;
    return s;
  }

  function aplicar(preco, dados) {
    if (!dados) return;
    var p = dados.p;
    var c = dados.c;
    var pv = dados.pv;
    if (!(pv > p)) return; /* sem PVPR maior do que o preço, não há nada a mostrar */
    if (c != null && c > p) return; /* riscado a sério: o PVPR não se mostra ao lado dele */
    if (!document.body.contains(preco)) return; /* o bloco pode ter saído do DOM entretanto */
    if (temRiscado(preco) || jaProcessado(preco)) return;
    /* O preço que o `?view=proa-pvpr` devolveu tem de ser o MESMO que o cartão já mostra.
       Se vier diferente (produto mudou de preço entretanto, ou a vista escolheu outra
       variante), o PVPR seria de uma variante que não é esta: não se mexe em nada. */
    if (precoMostrado(preco) !== p) return;

    preco.classList.add('proa-preco--pvpr');
    var envolvente = pedaco('proa-pvpr', '');
    envolvente.appendChild(pedaco('proa-pvpr__valor', euro(pv / 100)));
    envolvente.appendChild(document.createTextNode(' '));
    envolvente.appendChild(pedaco('proa-pvpr__sigla', 'PVPR'));
    preco.appendChild(envolvente);
  }

  function pedir(handle) {
    if (cache[handle]) return cache[handle];
    /* ⚠️ SEM `Accept: application/json`: a Shopify lê esse cabeçalho num pedido a uma
       página de produto e responde com o JSON interno do REST (`{"product": {...}}`),
       IGNORANDO o `?view=` e o tema por completo. Descoberto a testar contra a loja a
       sério: com o cabeçalho, nunca chega ao `templates/product.proa-pvpr.liquid`. */
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=proa-pvpr')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      });
    return cache[handle];
  }

  function processarFila() {
    while (emCurso < MAX_PARALELOS && fila.length) {
      var item = fila.shift();
      emCurso++;
      pedir(item.handle)
        .then(function (dados) {
          aplicar(item.preco, dados);
        })
        .catch(function () {})
        .then(function () {
          emCurso--;
          processarFila();
        });
    }
  }

  function porNaFila(preco) {
    var handle = preco.getAttribute('data-proa-pvpr');
    if (!handle) return;
    fila.push({ preco: preco, handle: handle });
    processarFila();
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        observador.unobserve(entrada.target);
        porNaFila(entrada.target);
      });
    },
    { rootMargin: '200px' }
  );

  function observar(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var precos = raiz.querySelectorAll('[data-proa-pvpr]');
    Array.prototype.forEach.call(precos, function (preco) {
      if (preco.__proaPvprObservado) return;
      if (!candidato(preco)) return;
      preco.__proaPvprObservado = true;
      observador.observe(preco);
    });
  }

  observar(document);

  /* Secções como o "Continua de onde ficaste" montam os cartões por
     JavaScript, depois deste ficheiro correr. Um MutationObserver no corpo
     da página apanha os blocos novos quando nascem, sem cada secção ter de
     chamar nenhuma função à parte. */
  var mutador = new MutationObserver(function () {
    observar(document);
  });
  mutador.observe(document.body, { childList: true, subtree: true });
})();
